// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__FJ_Qr","key":"styles_key__wX_g4","value":"styles_value__xmNV3"};
module.exports.__checksum = "6ead69128994"
